export class InvoiceModel {
    invoiceId: number;
    issueDate: Date;
    dueDate: Date;
    invoiceAmount: number;
    status: string;
    constructor(data: any) {
        this.invoiceId = data.invoiceId;
        this.issueDate = new Date(data.issueDate);
        this.dueDate = new Date(data.dueDate);
        this.invoiceAmount = data.invoiceAmount;
        this.status = data.status;
    }
};
